module.exports = __webpack_public_path__ + "img/about-04-partner.fa945ca8.png";